<template>
  <div class="relative">
    <div class="mt-huge">
      <div v-if="gallery.length >= 1 && Object.entries(gallery[0].image.Mobile).length !== 0">
        <h1 class="center">Event Gallery</h1>
        <gallery :images="images" :index="index" @close="index = null" :options="{vimeoClickToPlay: false}"></gallery>
        <ul class="list-reset gallery row clearfix mxn2 col-12 mxn2 mb3">
          <li class="col col-6 sm-col-4 lg-col-3 px2 pointer" v-for="(item, imageIndex) in gallery" :key="imageIndex" @click="index = imageIndex">
              <img class="p2" :src="item.image.Tablet.url" />
          </li>
        </ul>

        <div class="image-box col-6 md-col-6 lg-col-4 mx-auto center border mt3 top-break">
          <div class="m3">We would love you to post and submit your images to us <a href="mailto:press@firstthereisamountain.com">via email</a> or to social media with the tag <a href="https://www.instagram.com/explore/tags/firstthereisamountain/" target="_blank" class="link-border">#firstthereisamountain</a>.</div>
        </div>
      </div>
      <div v-else class="image-box col-6 md-col-6 lg-col-4 mx-auto center border">
        <div class="m3">Images and media from the event will be shown here. Check back soon, and we would love you to post and submit your images to us <a href="mailto:press@firstthereisamountain.com">via email</a> or social media with the tag <a href="https://www.instagram.com/explore/tags/firstthereisamountain/" target="_blank" class="link-border">#firstthereisamountain</a>.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getText } from '@/utils'
import gallery from 'vue-gallery'
export default {

  name: 'EventImages',

  data () {
    return {
      index: null,
      luminousGallery: null
    }
  },

  props: ['event'],

  components: {
    gallery
  },

  computed: {
    images () {
      var galleryItems = this.gallery.map(x => {
        return {
          title: this.getText(x['image-caption']),
          href: x.image.url,
          type: 'image/jpeg',
          poster: x.image.url
        }
      })
      return galleryItems
    },
    gallery () {
      return this.event.data['image-gallery']
    }
  },

  methods: {
    getText
  }
}
</script>

<style lang="css" scoped>
</style>
